import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export class NoTrailingSlashUrlSerializer extends DefaultUrlSerializer {
  serialize(tree: UrlTree): string {
    let url = super.serialize(tree);
    
    // Handle edge cases
    if (url === '/') return url;
    
    // Remove trailing slash and handle query params
    const [path, query] = url.split('?');
    const cleanPath = path.replace(/\/+$/, '');
    
    return query ? `${cleanPath}?${query}` : cleanPath;
  }

  parse(url: string): UrlTree {
    // Handle edge cases
    if (url === '/') return super.parse(url);
    
    // Remove trailing slash and handle query params
    const [path, query] = url.split('?');
    const cleanPath = path.replace(/\/+$/, '');
    const finalUrl = query ? `${cleanPath}?${query}` : cleanPath;
    
    return super.parse(finalUrl);
  }
}